<div class="kp-progress-ring mb-2" [style.width]="width" [style.height]="width" *ngIf="user?.Seeker">
  <div class="kp-progress-inner">
    <div class="kp-progress-fill" [style.top]="100- user.Seeker.Completeness + '%'"
      [style.background-color]="completenessColor(user.Seeker.Completeness)"></div>
    <div class="kp-progress-content">
      <img *ngIf="user.Seeker.Photo" class="w-100 h-100 cover " [src]="assetsUrl + user.Seeker.Photo"
        onerror="this.src='/assets/images/clipart/avatar-1.svg?err'">
      <div class="w-100 h-100 d-flex align-items-center justify-content-center f-white fs-lg text-shadow-kp"
        *ngIf="!user.Seeker?.Photo" [style.background-color]="'hsl(' + (user.Seeker.Code % 360) + 'deg ' + ((user.Seeker.Code % 25) + 30) + '% ' + ((user.Seeker.Code % 27) + 25) + '%)'">
        {{user.Initials}}
      </div>
    </div>
  </div>
  <div class="kp-progress-label">
    <span class="f-white fs-sm"
      [style.background-color]="completenessColor(user.Seeker.Completeness)">{{user.Seeker.Completeness}}%</span>
  </div>
</div>